// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","FilterLinks__link":"ce_a bhp_h bhp_kh bhp_we bhp_su bhp_vt bhp_sw bhp_sn"};